import { Head, router, usePage } from '@inertiajs/react';
import { useState } from 'react';
import AuthLayout from '@/components/auth/AuthLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import FlashBanner from '@/components/ui/flash-banner';

type PageProps = {
  resetToken: string;
};

export default function ResetPassword() {
  const { props } = usePage<PageProps>();
  const token = props.resetToken;

  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    router.put(
      '/patients/password',
      { patient: { reset_password_token: token, password, password_confirmation: passwordConfirmation } },
      {
        preserveScroll: true,
        onError: (errors) => {
          const first = Object.values(errors)[0] as string;
          setError(first || 'Errore nel reset');
        },
        onFinish: () => setIsSubmitting(false),
        onSuccess: (page) => {
          const flash = (page.props as { flash?: { alert?: string } }).flash || {};
          if (flash.alert) {
            setError(flash.alert as string);
            return;
          }

          // Devise controller fa redirect alla dashboard paziente; seguiamo il redirect
          window.location.href = '/patients/dashboard';
        },
      }
    );
  };

  return (
    <AuthLayout>
      <Head title="Reimposta password" />
      <div className="w-full max-w-md">
        <Card className="rounded-3xl border-white/20 bg-white/90 backdrop-blur-xl shadow-[0_30px_80px_-20px_rgba(0,0,0,0.45),0_25px_60px_-15px_rgba(120,64,255,0.25)]">
          <CardHeader>
            <CardTitle className="text-2xl font-semibold tracking-tight text-slate-900">Crea una nuova password</CardTitle>
            <CardDescription className="text-base text-slate-600">Assicurati che sia lunga almeno 8 caratteri.</CardDescription>
          </CardHeader>
          <CardContent>
            {error && <FlashBanner message={error} tone="error" className="mb-3" />}
            <form className="space-y-6" onSubmit={submit}>
              <div className="space-y-2">
                <Label htmlFor="password">Nuova password</Label>
                <Input
                  id="password"
                  type="password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isSubmitting}
                  autoComplete="new-password"
                  className="bg-white/95 text-slate-900 focus:bg-white border-slate-200"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password_confirmation">Conferma password</Label>
                <Input
                  id="password_confirmation"
                  type="password"
                  required
                  minLength={8}
                  value={passwordConfirmation}
                  onChange={(e) => setPasswordConfirmation(e.target.value)}
                  disabled={isSubmitting}
                  autoComplete="new-password"
                  className="bg-white/95 text-slate-900 focus:bg-white border-slate-200"
                />
              </div>
              <Button
                type="submit"
                className="w-full"
                style={{ backgroundColor: 'var(--emovia-primary)' }}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Salvataggio...' : 'Aggiorna password'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </AuthLayout>
  );
}
